<styles-sidenav-content-spacer menuFeeds="true">
  <bread-crumb>
    <styles-bread-crumb icon="dataset" title="Search {{searchTerm ? (' - ' + searchTerm) : ''}}" #breadcrumb>
    </styles-bread-crumb>
  </bread-crumb>

  <div class="search-header">Search Results {{searchTerm ? (' - ' + searchTerm) : ''}}</div>

  <div class="search-numbers">
    <mat-icon>search</mat-icon> {{numberOfHits && numberOfHits > 0 ? numberOfHits + ' / 500' : 0}} Results
  </div>

  <div class="search-wrapper">
    <search-results-box [searchResults]="searchResults$"></search-results-box>
  </div>
</styles-sidenav-content-spacer>
